// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"6a3190f26f503ac0d0d7","339":"232c98a410606efcc0cf"}[chunkId] + ".js";
};